const ENDPOINT = 'GETartistProfileClaimed';
function getArtistProfileClaimed(gateway, params = {}) {
    return gateway.get(getArtistProfileClaimed.endpoint, params);
}
getArtistProfileClaimed.endpoint = ENDPOINT;

export { getArtistProfileClaimed as default };
//# sourceMappingURL=getArtistProfileClaimed.js.map
